import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";

type ThankYouData = {
    imageSrc: string;
    title: string;
    description: string;
    buttonLabel: string;
    buttonUrl: string;
  };
  
  const ThankYou = () => {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const data: ThankYouData = {
      imageSrc: "/general/thank_you.webp",
      title: "We are Here For You - Just sit back and relax",
      description: "While you wait, why not dive into some travel inspiration on our blog?",
      buttonLabel: "Get Inspired !",
      buttonUrl: "/blogs",
    };
  
    return (
    <>
    <HelmetProvider>
        <Helmet>
          <title>Thank You | Halo Holidays</title>
          <meta name="description" content="Thank you for choosing Halo Holidays! We appreciate your business and look forward to helping you plan your next adventure." />
        </Helmet>
    </HelmetProvider>
    <Header />
      <section className="pb-20 pt-28">
        <div className="container mx-auto px-4 mt-20">
          <div className="flex flex-wrap justify-between items-center gap-8">
            <div className="w-full lg:w-1/4 p-4 md:p-0 md:ml-28">
              <img src={data.imageSrc} alt="Thank you image" className="w-full" />
            </div>
            <div className="w-full lg:w-2/4">
              <div className="text-center lg:text-left">
                <div className="text-6xl font-bold mb-5">
                  THANK<span className="text-halo-pink"> YOU</span>
                </div>
                <h2 className="text-2xl font-semibold">
                  We are <span className="text-halo-pink">Here For You</span> - Just sit back and relax
                </h2>
                <p className="mt-8 mb-8 lg:pr-8">{data.description}</p>
                <div className="inline-block mt-10 lg:mt-5">
                  <Link to={data.buttonUrl}>
                    <a className="px-6 py-3 bg-halo-pink text-white rounded-md text-lg hover:bg-pink-800">
                      {data.buttonLabel}
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
    );
  };

export default ThankYou;